import React from "react"
import classnames from "classnames"
import styles from "./SlugIcon.less"
import ArrowDownIcon from './../ArrowDownIcon'

const SlugIcon = ({style}) => {
  return (
    <div
      className={classnames({
        [styles.SlugIcon]: true,
      })}
      style={style}
    >
      <ArrowDownIcon />
    </div>
  )
}

export default SlugIcon




// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/SlugIcon/SlugIcon.jsx